<section class="cmn-innerpage-wrapper">
  <div class="inner-content dashboard">
    <div class="head">
      <h1>Info Pages</h1>

    <button class="cmn-add-btn" *ngIf="!loading && staticContentList.length < 4" (click)="addStaticPage()">
      Add Info Page
    </button>
    </div>

    <div class="grid-wrapper" *ngIf="!loading">
      <div
        class="pageItem"
        *ngFor="let item of staticContentList; let i = index"
      >
        <div
          class="imageWrapper"
          (click)="viewStaticPage(item.staticContentId)"
        >
          <img src="assets/images/icons/static-page-primary.svg" />
        </div>

        <div class="text-key">
          <h3 [innerHTML]="item.key.replaceAll('_', ' ')"></h3>
        </div>

        <div class="actionWrapper">
          <div *appHasPermission="'UPDATE_INFO_PAGE'" class="actionItem"
            (click)="onEditStaticPage(item.staticContentId)">
            <img src="../../../assets/images/icons/icon-edit.svg" alt="Edit" />
          </div>
        </div>
      </div>
    </div>

    <app-content-loader [visible]="loading"></app-content-loader>
  </div>

  <!-- No Data -->
  <div *ngIf="staticContentList?.length === 0 && !loading">
    <app-no-data-component></app-no-data-component>
  </div>
</section>
